import { FormattedMessage } from "react-intl";

import ConsultConflict from "@components/ConsultConflict";
import DateAndTimeStamp from "@components/dates/DateAndTimeStamp";
import HugeText from "@components/text/HugeText";
import { GetOutOfOfficePeriodQuery } from "@typing/Generated";

type Props = {
  outOfOfficePeriod: GetOutOfOfficePeriodQuery["outOfOfficePeriod"];
  userIsExpert?: boolean;
};

const ConsultConflicts = ({ outOfOfficePeriod }: Props) => (
  <div>
    <div>
      <HugeText>
        <FormattedMessage id="pages.expert.outOfOffice.eventScheduled" />
      </HugeText>
    </div>
    <dl>
      <dt>
        <FormattedMessage id="pages.expert.outOfOffice.expertOutOfTheOffice" />
      </dt>
      <dd>{outOfOfficePeriod.expert.fullName}</dd>
      <dt>
        <FormattedMessage id="pages.expert.outOfOffice.firstDay" />
      </dt>
      <dd>
        <DateAndTimeStamp value={outOfOfficePeriod.startTime} />
      </dd>
      <dt>
        <FormattedMessage id="pages.expert.outOfOffice.lastDayOut" />
      </dt>
      <dd>
        <DateAndTimeStamp value={outOfOfficePeriod.endTime} />
      </dd>
      <dt>
        <FormattedMessage id="pages.expert.outOfOffice.backupExpert" />
      </dt>
      <dd>{outOfOfficePeriod.backupExpert.fullName}</dd>
    </dl>
    <div>
      <HugeText>
        <FormattedMessage
          id="pages.expert.outOfOffice.duringEvent"
          values={{ count: outOfOfficePeriod.consultConflicts?.length ?? 0 }}
        />
      </HugeText>
    </div>
    {outOfOfficePeriod.consultConflicts?.map(consult => <ConsultConflict consult={consult} key={consult.id} />)}
  </div>
);

export default ConsultConflicts;
